<template>
	<v-flex>
		<v-autocomplete
				:error-messages="$props.error"
				:items="options"
				:label="$props.label"
				:placeholder="' '"
				:multiple="true"
				:readonly="readonly"
				class="ml-2 mr-2" item-text="label" item-value="value" v-if="!isSimple"
				v-model="selectedValue">
			<template #prepend-item>
				<slot name="firstItem"></slot>
			</template>
			<template #prepend>
				<slot name="prepend"></slot>
			</template>

		</v-autocomplete>
		<v-autocomplete
				:items="options"
				:multiple="true"
				:readonly="readonly"
				class="ml-2 mr-2 simple"
				hide-details item-text="label" item-value="value" v-if="isSimple"
				v-model="selectedValue">
			<template #prepend-item>
				<slot name="firstItem"></slot>
			</template>
			<template #prepend>
				<slot name="prepend"></slot>
			</template>

		</v-autocomplete>
	</v-flex>
</template>

<script>
	export default {
		name: "DropdownMultiple",
		props: ['simple', 'readonly', 'value', 'ajax', 'data', 'label', 'error'],
		data() {
			return {
				endpoint: '',
				selectedValue: null,
				options: [],
				ajaxLoaded: false,
				protected: null
			}
		},
		computed: {
			isSimple() {
				return (typeof this.$props.simple !== 'undefined');
			}
		},
		watch: {
			value: function (newVal, oldVal) {
				if (newVal != oldVal) {
					if (newVal != this.selectedValue) {
						this.protected = newVal;
						this.setValue(newVal);
					}
				}
			},
			selectedValue: function (val) {
				if (val != this.$props.value) {
					if (val != null) {
						if (val != this.$props.value) {
							this.$nextTick(() => {
								this.$emit('input', val);
							})
						}
					} else {
						this.$nextTick(() => {
							this.$emit('input', null);
						})
					}
					this.$nextTick(() => {
						this.callChange();
					});
				}
			},
		},
		methods: {
			callChange() {
				this.$emit('changes');
			},
			setValue(newVal) {
				if (this.$props.ajax) {
					var vm = this;
					this.$APICall('get', 'select/' + this.endpoint, {protected: this.protected}, (data, success) => {
						if (success) {
							vm.options = data;
							vm.ajaxLoaded = true;
							if (newVal == vm.$props.value) {
								vm.selectedValue = newVal;
							}
						}
					}, false);

				} else {
					this.options = this.$props.data;
					this.selectedValue = newVal;
				}
			}
		},
		mounted() {
			if (this.$props.ajax) {
				this.endpoint = this.$props.data;
			}
			this.protected = this.$props.value;
			this.setValue(this.$props.value);
		}
	}
</script>

<style scoped>
	.simple {
		padding: 0px;
		margin: 0px;
	}
</style>
